import React from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { navigate } from "gatsby";
import "./ctaBanner.scss"
import TitleSection from "../title-section";

const CtaBanner = (props: ReferenciaContenido) => {
    console.log(props);
    return (
        <section className="m-cta-banner">
            <img className="m-cta-banner__img" src={props.imagenPrincipal.file.url}/>
            <div className="m-cta-banner__info-container">
                <div className="m-cta-banner__title">
                    <TitleSection title={props.tituloGeneral} />
                </div>
                <p className="m-cta-banner__description">{props.tituloSeccion}</p>
                <button className="m-cta-banner__cta" onClick={() =>{navigate(props.redireccionBoton)}}>{props.tituloBoton}</button>
            </div>
        </section>
    );
};

export default CtaBanner;